import { render } from "./lists_card.vue?vue&type=template&id=50e00ac0"
import script from "./lists_card.js?vue&type=script&lang=js"
export * from "./lists_card.js?vue&type=script&lang=js"

import "./lists_card.vue?vue&type=style&index=0&id=50e00ac0&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__